module.exports = __webpack_public_path__ + "media/images/heroes/live-f5232f00f1d6a94d44616a64e5c28ea0.png";